import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '../../services/auth/auth.service'
import { Router } from '@angular/router';

@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.css']
})
export class AuthComponent implements OnInit {

  authCode: any = null;
  authenticated = false;
  failedAuth: boolean;

  constructor(
    private route: ActivatedRoute,
    public auth: AuthService,
    private router: Router
  ) { }

  async ngOnInit() {
    if (await this.auth.isAuthenticated()) {
      this.router.navigate(['home']);
    } else {
      let authCodeParam = this.route.snapshot.queryParamMap.get('code');
      if (authCodeParam) {
        this.auth
          .getNewTokens(authCodeParam)
          .then(_ => {
            this.router.navigate(['home']);
          })
          .catch(e => {
            console.error('e: ', e);
            this.router.navigate(['login']);
          });
      } else {
        this.auth.initAuth();
      }
    }
  }
}
